import PropTypes from "prop-types";

const FormSection = ({ title }) => (
  <h3 className="tw:mt-2 tw:mb-1 tw:font-heading tw:text-base tw:font-medium tw:text-foreground">
    {title}
  </h3>
);

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
};

export default FormSection;
